







































import { Component, Vue, Watch } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';
import Paging from '@/shared/components/Paging.vue';
import FilterBox from './components/FilterBox.vue';
import ListQuotation from './components/ListQuotation.vue';
import FooterBar from './components/FooterBar.vue';
import Filtering from '@/shared/components/Filtering.vue';
import quotationServices from '@/services/quotation-services';
import commonService from '@/services/common-services';
import { DATA } from '@/config/data';
import { APP_CONFIG } from '@/config/app-config';

@Component({
    components: {
        Loading,
        FilterBox,
        Filtering,
        ListQuotation,
        Paging,
        FooterBar,
    }
})
export default class List extends Vue {
    private isLoading: boolean = false;
    private items: any[] = [];
    private currentStatus: string = 'all';
    private searchTerm: string = '';
    private currentPage: number = 1;
    private rowsPerPage: number = 10;
    private totalRows: number = 0;
    private totalPages: number = 1;

    private filters: any[] = [];
    private quickFilters: any[] = [];

    get warehouse() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].warehouse || [];
    }

    get chinaStore() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].chinaStore || [];
    }

    get headers() {
        return [
            {
                text: "Mã báo giá",
                value: "display_id",
                filterable: true,
                quickSearch: true,
                dataType: DATA.DATA_TYPE["String"]
            },
            {
                text: "Trạng thái",
                value: "status",
                filterable: true,
                dataType: DATA.DATA_TYPE["Enum"],
                values: [
                    { value: 'draft', name: 'Nháp' },
                    { value: 'cho-duyet', name: 'Chờ duyệt' },
                    { value: 'da-gui', name: 'Đã gửi KH' },
                    { value: 'kh-da-duyet', name: 'KH đã duyệt' },
                    { value: 'xnk-da-duyet', name: 'XNK đã duyệt' },
                    { value: 'cho-xep-xe', name: 'Chờ xếp xe' },
                    { value: 'dang-van-chuyen', name: 'Đang vận chuyển' },
                    { value: 'da-nhap-kho-nhan', name: 'Nhập kho VN' },
                    { value: 'hoan-thanh', name: 'Hoàn thành' },
                    { value: 'huy', name: 'Đã hủy' }
                ]
            },
            {
                text: "Dịch vụ",
                value: "service_type",
                filterable: true,
                dataType: DATA.DATA_TYPE["Enum"],
                values: [
                    { value: 'ENTRUSTMENT', name: 'Ủy thác XNK' },
                    { value: 'SPLIT', name: 'Tách tờ khai' }
                ]
            },
            {
                text: "Điều kiện VC",
                value: "declaration_condition",
                filterable: true,
                dataType: DATA.DATA_TYPE["Enum"],
                values: [
                    { value: 'ETL', name: 'ETL (Ủy thác bộ)' },
                    { value: 'ECL', name: 'ECL (Ủy thác cont)' },
                    { value: 'EFT', name: 'EFT (Ủy thác nguyên xe)' },
                    { value: 'EFC', name: 'EFC (Ủy thác nguyên cont)' },
                    { value: 'LCL', name: 'LCL (Tách cont LCL)' },
                    { value: 'FCL', name: 'FCL (Tách cont FCL)' },
                    { value: 'FTL', name: 'FTL (Tách nguyên xe)' },
                    { value: 'LTL1', name: 'LTL1 (UNS TQ xuất - Khách nhập)' },
                    { value: 'LTL2', name: 'LTL2 (Xưởng TQ xuất - Khách nhập)' },
                    { value: 'LTL3', name: 'LTL3 (UNS TQ xuất - Thuê GP xuất - Khách nhập)' },
                    { value: 'LTL4', name: 'LTL4 (UNS TQ xuất - Thuê GP xuất TQ - UNS nhập)' },
                    { value: 'LTL5', name: 'LTL5 (Xưởng TQ xuất - UNS nhập)' }
                ]
            },
            {
                text: "Kho TQ",
                value: "legacy_china_store_id",
                filterable: true,
                dataType: DATA.DATA_TYPE["Enum"],
                values: this.chinaStore.map((x: any) => ({
                    value: x.ID,
                    name: x.Name
                }))
            },
            {
                text: "Kho VN",
                value: "legacy_receive_place_id",
                filterable: true,
                dataType: DATA.DATA_TYPE["Enum"],
                values: this.warehouse.map((x: any) => ({
                    value: x.ID,
                    name: x.Name
                }))
            },
            {
                text: "Mã vận đơn",
                value: "trackings__tracking_code",
                filterable: true,
                quickSearch: true,
                dataType: DATA.DATA_TYPE["String"]
            },
            {
                text: "Tên hàng",
                value: "items__ten_hang",
                filterable: true,
                quickSearch: true,
                dataType: DATA.DATA_TYPE["String"]
            },
            {
                text: "Ghi chú",
                value: "customer_note",
                filterable: true,
                dataType: DATA.DATA_TYPE["String"]
            },
            {
                text: "Tổng chi phí",
                value: "total_cost",
                filterable: true,
                dataType: DATA.DATA_TYPE["Number"]
            },
            {
                text: "Đã thanh toán",
                value: "da_thanh_toan",
                filterable: true,
                dataType: DATA.DATA_TYPE["Number"]
            },
            {
                text: "Còn thiếu",
                value: "con_thieu",
                filterable: true,
                dataType: DATA.DATA_TYPE["Number"]
            },
            {
                text: "Ngày tạo",
                value: "created_at",
                filterable: true,
                dataType: DATA.DATA_TYPE["Date"]
            }
        ];
    }

    private async created() {
        if (this.$route.query && this.$route.query.status) {
            this.currentStatus = String(this.$route.query.status);
        }
        if (this.$route.query && this.$route.query.page) {
            const pageNum = parseInt(String(this.$route.query.page), 10);
            if (pageNum > 0) {
                this.currentPage = pageNum;
            }
        }
        if (!this.warehouse || this.warehouse.length === 0) {
            await this.getWarehouse();
        }
        if (!this.chinaStore || this.chinaStore.length === 0) {
            await this.getChinaStore();
        }
        await this.loadData();
    }

    @Watch('$route.query')
    private onRouteQueryChange(newQuery: any) {
        const queryStatus = (newQuery && newQuery.status) ? String(newQuery.status) : 'all';
        const queryPage = (newQuery && newQuery.page) ? (parseInt(String(newQuery.page), 10) || 1) : 1;

        let needsReload = false;
        if (this.currentStatus !== queryStatus) {
            this.currentStatus = queryStatus;
            needsReload = true;
        }
        if (this.currentPage !== queryPage) {
            this.currentPage = queryPage;
            needsReload = true;
        }
        if (needsReload) {
            this.loadData();
        }
    }

    private updateQueryString(params: Record<string, any>) {
        const query: Record<string, any> = { ...this.$route.query, ...params };

        for (const k of Object.keys(query)) {
            if (query[k] === undefined || query[k] === null || query[k] === '') {
                delete query[k];
            }
        }

        if (query.page === 1 || query.page === '1') {
            delete query.page;
        }

        const currentQuery = this.$route.query;
        const currentKeys = Object.keys(currentQuery);
        const newKeys = Object.keys(query);
        const isSame = currentKeys.length === newKeys.length &&
            currentKeys.every(k => String(currentQuery[k]) === String(query[k]));

        if (!isSame) {
            this.$router.push({ query }).catch(() => {});
        }
    }

    private async getWarehouse() {
        try {
            const result = await commonService.getWarehouse();
            if (result && result.status === 200) {
                (window['getApp'] as any).$emit('SET_WAREHOUSE', result.data.data);
            }
        } catch (e) {}
    }

    private async getChinaStore() {
        try {
            const result = await commonService.getChinaStore();
            if (result && result.status === 200) {
                (window['getApp'] as any).$emit('SET_CHINASTORE', result.data.data);
            }
        } catch (e) {}
    }

    private mapConditionToOfficialOperator(cond: string): string {
        switch (cond) {
            case 'contain':
                return 'contains';
            case 'does_not_contain':
                return 'not_contains';
            case 's_equal':
            case 'equal':
                return 'eq';
            case 's_does_not_equal':
            case 'does_not_equal':
                return 'neq';
            case 'greater_than':
                return 'gt';
            case 'greater_than_or_equal':
                return 'gte';
            case 'less_than':
                return 'lt';
            case 'less_than_or_equal':
                return 'lte';
            case 'in':
                return 'in';
            case 'not_in':
                return 'not_in';
            case 'd_equal':
                return 'date_eq';
            case 'd_does_not_equal':
                return 'neq';
            case 'd_greater_than':
                return 'date_after';
            case 'd_greater_than_or_equal':
                return 'gte';
            case 'd_less_than':
                return 'date_before';
            case 'd_less_than_or_equal':
                return 'lte';
            default:
                return cond || 'eq';
        }
    }

    private onBuildFilter(): any {
        const officialParams: any = {};
        const validFilters: any[] = [];

        if (this.filters && this.filters.length > 0) {
            for (const item of this.filters) {
                if (item.value === undefined || item.value === null || item.value === '') continue;
                if (Array.isArray(item.value) && item.value.length === 0) continue;
                validFilters.push({
                    column: item.column,
                    operator: this.mapConditionToOfficialOperator(item.condition),
                    value: item.value
                });
            }
        }

        if (validFilters.length > 0) {
            officialParams.condition = 'AND';
            validFilters.forEach((f, i) => {
                officialParams[`f[${i}][col]`] = f.column;
                officialParams[`f[${i}][op]`] = f.operator;
                if (Array.isArray(f.value)) {
                    officialParams[`f[${i}][val]`] = f.value.map((v: any) => String(v));
                } else {
                    officialParams[`f[${i}][val]`] = String(f.value);
                }
            });
        }

        return officialParams;
    }

    private async loadData() {
        this.isLoading = true;
        try {
            const officialFilters = this.onBuildFilter();
            const res: any = await quotationServices.getList(
                this.currentPage,
                this.rowsPerPage,
                this.currentStatus,
                this.searchTerm,
                officialFilters
            );
            if (res && res.data && res.data.status === 200) {
                this.items = res.data.data || [];
                this.totalRows = res.data.total || 0;
                this.totalPages = res.data.num_pages || Math.ceil(this.totalRows / this.rowsPerPage) || 1;
            } else {
                this.items = [];
                this.totalRows = 0;
                this.totalPages = 1;
            }
        } catch (e) {
            this.items = [];
        } finally {
            this.isLoading = false;
        }
    }

    private onChangeStatus(status: string) {
        if (this.currentStatus === status && (this.$route.query.status || 'all') === status) {
            return;
        }
        this.currentStatus = status;
        this.currentPage = 1;
        this.updateQueryString({ status: status === 'all' ? undefined : status, page: undefined });
        this.loadData();
    }

    private applyFilter(data: any) {
        this.filters = data || [];
        this.currentPage = 1;
        this.loadData();
    }

    private quickFilter(data: any) {
        this.quickFilters = data || [];
        if (data && data.length > 0) {
            this.searchTerm = data[0].value;
        } else {
            this.searchTerm = '';
        }
        this.currentPage = 1;
        this.loadData();
    }

    private changePage(page: number) {
        if (page < 1 || page > this.totalPages || page === this.currentPage) return;
        this.currentPage = page;
        this.updateQueryString({ page: page > 1 ? page : undefined });
        this.loadData();
    }
}
